@if (digitalMenu) {
<div class="grid-height" [ngStyle]="{'height': digitalMenu.Orientation ? digitalMenu?.Width + 'px' :digitalMenu?.Height + 'px' ,
 'width': digitalMenu.Orientation ? digitalMenu?.Height + 'px' : digitalMenu?.Width + 'px'}">
    <gridster [options]="options" [ngStyle]="{'--menu-background-color': menuDisplayConfig?.BackgroundColor}">
      @for (item of menuWidgets; track item; let index = $index) {
        <div class="display-contents">
          <gridster-item [item]="item.GridItem" class="widget-border-{{item.Id}} widget-background-{{item.Id}}"
            [ngClass]="{'display-none-imp': item.WidgetType == groupWidgetName}">
            <pos-menu-widget [widgetType]="item.WidgetType" [widgetId]="item.Id" [previewMode]="true"
              [widgetIndex]="index" (widgetDelete)="deleteWidget($event)" (reload)="reload($event)">
            </pos-menu-widget>
          </gridster-item>
        </div>
      }
    </gridster>
  </div>
}
@if (slideshowData && slideshowData?.length > 0) {
<div id="mediaRotator" class="height-100vh menu-overlay">
  <pos-media-rotator [media]="slideshowData"></pos-media-rotator>
</div>
}
